import React from 'react'
import { BusinessDetails } from '../component'
import DashboardLayout from '../layouts/DashboardLayout'

function PgDashboard() {
    return (
        <DashboardLayout>
            <BusinessDetails/>
        </DashboardLayout>
    )
}

export default PgDashboard
